import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { Router } from '@angular/router';
import { ProjectIdeaFieldsComponent } from '@app/components/project-idea-fields/project-idea-fields.component';
import { FileData, UploadService } from '@app/services/file/upload.service';
import { ProjectSetupStore } from '@app/stores/project-setup/project-setup.store';
import { ButtonComponent } from '@app/ui-components/button/button.component';
import { CardComponent } from '@app/ui-components/card/card.component';
import { TranslateModule } from '@ngx-translate/core';
import {
  getFileDataFormFileUploadForm,
  isFormValid,
} from 'src/app/+helpers/form.helper';
import { GenericStore } from 'src/app/+store/generic.store';
import {
  convertFormToProjectIdeaInput,
  getNewProjectFormGroup,
  NewProjectFormGroup,
} from './new-project-form.helper';

@Component({
  selector: 'app-new-project-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    CardComponent,
    ProjectIdeaFieldsComponent,
    ButtonComponent,
  ],
  templateUrl: './new-project-form.component.html',
  styleUrl: './new-project-form.component.scss',
})
export class NewProjectFormComponent {
  protected genericStore = inject(GenericStore);
  protected projectSetupStore = inject(ProjectSetupStore);

  protected loading = signal(false);

  protected projectIdeaForm: FormGroup<NewProjectFormGroup>;
  constructor(
    private fb: FormBuilder,
    private destroyRef: DestroyRef,
    private uploadService: UploadService,
    private router: Router,
  ) {
    this.projectIdeaForm = getNewProjectFormGroup(fb);
  }

  protected submitIdea(): void {
    if (!isFormValid(this.projectIdeaForm)) {
      return;
    }
    this.loading.set(true);

    this.projectSetupStore
      .createProjectIdea(convertFormToProjectIdeaInput(this.projectIdeaForm))
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((project) => {
        const filesArray = this.projectIdeaForm.controls.files;
        const filePayload = filesArray.controls
          .map((g) => getFileDataFormFileUploadForm(g))
          .filter((d): d is FileData => d !== null);

        if (filePayload.length === 0) {
          this.loading.set(false);
          this.router.navigateByUrl('/profile');
        }

        filePayload.length > 0 &&
          this.uploadService
            .uploadFilesForProject(project.id, filePayload)
            .subscribe(() => {
              this.loading.set(false);
              this.router.navigateByUrl('/profile');
            });
      });
  }
}
